import React, { createContext } from "react";

export const ReviewIssueContext = createContext(null);

export function focusReviewField(id) {
  const field = document.getElementById(id);
  if (!field) return;
  field.focus({ preventScroll: true });
  field.scrollIntoView({ block: "center", inline: "nearest" });
}

export function CloseFieldEdit({ onClick }) {
  return (
    <button
      type="button"
      className="premium-edit-toggle premium-close-field"
      onClick={onClick}
      aria-label="Zamknij edycję pola"
      title="Zamknij edycję pola"
    >
      <i className="bi bi-x-lg" aria-hidden="true" />
    </button>
  );
}

export default function ReviewIssueHint({ selection }) {
  return (
    <div className="premium-issue-hint">
      <span id={`${selection.id}-hint`}>{selection.issue.message}</span>
      <button type="button" onClick={selection.edit}>
        <i className="bi bi-pencil" aria-hidden="true" /> Popraw
      </button>
    </div>
  );
}
